import { CalendarDate } from '#utils/UNSAFE_calendarDateUtils';
import { Keys } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';
import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { TestElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';
export class InputDateMaskAdapter extends TestAdapter {
  /**
   * Clear and commit the value of the component
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }

  /**
   * Change and commit the value of the component
   * @param value {CalendarDate | undefined} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: CalendarDate | undefined) {
    const driver = this.getTestDriver();
    const el = await this.getElement();

    // Deleting segments one at a time, rather than using Control-A to select all
    // and then delete, works better on Safari and Firefox.
    const monthSegment = await el.waitForElement(byCss(`div[data-segment="month"]`));
    await driver.click(monthSegment);
    await driver.sendKeys(monthSegment, Keys['DELETE']);

    let daySegment: TestElement | undefined;
    try {
      daySegment = await el.waitForElement(byCss(`div[data-segment="day"]`));
      await driver.click(daySegment);
      await driver.sendKeys(daySegment, Keys['DELETE']);
    } catch (_e) {
      // The day segment may not exist depending on the granularity.
      // If the segment isn't found there's nothing to update.
    }

    const yearSegment = await el.waitForElement(byCss(`div[data-segment="year"]`));
    await driver.click(yearSegment);
    await driver.sendKeys(yearSegment, Keys['DELETE']);

    if (value !== undefined) {
      if (value.month !== undefined) {
        await driver.click(monthSegment);
        await driver.sendKeys(monthSegment, '' + value.month);
      }

      if (daySegment && value.day !== undefined) {
        await driver.click(daySegment);
        await driver.sendKeys(daySegment, '' + value.day);
      }

      // Update the year. Send the keys one at a time, because otherwise the year segment
      // only seems to end up with the last two digits of the year (webdriver only, works
      // fine in Jest).
      if (value.year !== undefined) {
        await driver.click(yearSegment);
        const year = '' + value.year;

        for (let i = 0; i < year.length; i++) {
          await driver.sendKeys(yearSegment, year.charAt(i));
        }
      }
    }

    // Commit.
    await driver.sendKeys(yearSegment, Keys['ENTER']);
  }
}
